import React, { useEffect, useState } from 'react';
import { IPageData } from '../../../../interfaces/page';
import { useFetchPageData, usePageData } from '../../../../hooks/usePage';
import { Button, Card, message, Modal, Result, Spin, Tooltip } from 'antd';
import { Bar, Pie } from 'react-chartjs-2';
import { IEleccion } from '../../../../interfaces/elecciones/eleccion';
import { IResponse } from '../../../../interfaces/response';
import eleccionesProvider from '../../../../services/eleccionesProvider';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { IConteoVotos } from '../../../../interfaces/elecciones/graficos';
import { navigateHome } from '../../../../utils/naviagate-home';
import reportesProvider from '../../../../services/reportesProvider';
import { saveAs } from 'file-saver';
import moment from 'moment';

const { confirm } = Modal;

const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Comité SST',
      route: 'default-dashboard'
    },
    {
      title: 'Resultados'
    }
  ]
};
const ResultadoElecciones = () => {
  usePageData(pageData);
  const [data] = useFetchPageData<IEleccion>('/elecciones/ObtenerEleccionVIgente', null);

  const [asistencia, setasistencia] = useState<any>();
  const [resultadofinal, setresultadofinal] = useState<any>();
  const [conteovotos, setconteovotos] = useState<IConteoVotos>();

  const [guardando, setguardando] = useState(false);
  useEffect(() => {
    console.log('', data);
  }, [data]);

  useEffect(() => {
    obtenerGraficos();
    return () => {
      console.log('salio del effect');
    };
  }, []);

  const obtenerGraficos = async () => {
    const res: any = await eleccionesProvider.obtenerResultadosVigentes();
    if (res.succeeded) {
      setresultadofinal(res.data.grafico1);
      setasistencia(res.data.grafico2);
      setconteovotos(res.data.grafico3);
    }
  };

  const cierreDefinitivo = async () => {
    confirm({
      title: 'El proceso de elección ha finalizado?',
      icon: <ExclamationCircleOutlined />,
      content: 'Si preciona el boton OK, se guardara el proceso para su posterior auditoria.',
      onOk() {
        return new Promise((resolve, reject) => {
          setguardando(true);
          data.eleccion.cierreTotal = true;
          data.eleccion.activo = false;
          eleccionesProvider
            .guardarEleccion(data.eleccion)
            .then((res: any) => {
              //TODO VALIDAR
              if (res.succeeded) {
                message.success(res.message, 10);
              } else {
                message.warning(res.message, 10);
              }
              setguardando(false);
              resolve('');
            })
            .catch((err) => {
              console.log(err);
              reject();
            });
        })
          .then((res) => {
            console.log(res);
            navigateHome();
          })
          .catch(() => console.log('Oops errors!'));
      },
      onCancel() {}
    });
  };
  const generarPadron = async () => {
    setguardando(true);
    const res = await reportesProvider.exportarPadron(0);
    saveAs(res.data, `Padron Electoral-${moment(new Date()).format('L')}.xlsx`);
    setguardando(false);
  };

  const cierreCompleto = () => (
    <div>
      <Tooltip title='Generar el padron electoral.'>
        <Button htmlType={'button'} size={'small'} onClick={generarPadron} type='primary'>
          GENERAR PADRON
        </Button>
      </Tooltip>
      <Tooltip title='El proceso de cierre tiene caracter definitivo y quedara registrado como historico de elección.'>
        <Button
          htmlType={'button'}
          size={'small'}
          disabled={!data.eleccion.finVotacion}
          onClick={cierreDefinitivo}
          style={{ marginBottom: 5, backgroundColor: 'red', borderColor: 'red' }}
          type='primary'
        >
          CIERRE DEFINITIVO
        </Button>
      </Tooltip>
    </div>
  );

  const optionPie = {
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat(((currentValue / total) * 100).toFixed(1));
          return currentValue + ' (' + percentage + '%)';
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    }
  };

  const opcionBarra = {
    tooltips: {
      callbacks: {
        label: function (i, d) {
          var dataset = d.datasets[i.datasetIndex];
          const count = data.usuariosHabilitados.length;
          var currentValue = dataset.data[i.index];
          var percentage = parseFloat(((currentValue / count) * 100).toFixed(1));
          return `${currentValue} (${percentage}%)`;
        },
        title: function (i, d) {
          return d.labels[i[0].index];
        }
      }
    }
  };

  return (
    <>
      {data != null && data.eleccion != null ? (
        <Spin spinning={guardando}>
          <Card title={'Proceso de elección de los Representantes de los Trabajadores para el Comité de Intervención frente al Hostigamiento Sexual Laboral 2026-2028 de TGESTIONA SERVICIOS GLOBALES S.A.C'} extra={cierreCompleto()}>
            <div className='row'>
              <div className='col-md-12'>
                <Card
                  title={
                    data.eleccion.finVotacion
                      ? 'Resultados finales'
                      : '...En proceso Resultados finales'
                  }
                  loading={!data.eleccion.finVotacion}
                >
                  {resultadofinal && resultadofinal.datasets ? <Pie data={resultadofinal} /> : null}
                </Card>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-4'>
                <Card title='% Participación de Votantes'>
                  {asistencia.datasets ? <Pie data={asistencia} options={optionPie} /> : null}
                </Card>
              </div>
              <div className='col-md-8'>
                <Card title={'Conteo de Votos'}>
                  <Bar {...conteovotos} options={opcionBarra} />
                </Card>
              </div>
            </div>
          </Card>
        </Spin>
      ) : (
        <Result status='info' title='GESSOMA' subTitle='Actualmente se encuentra en proceso.' />
      )}
    </>
  );
};
export default ResultadoElecciones;
